import { MouseEvent as ReactMouseEvent } from 'react';
import { ICenterAddress } from '@nkr/models/index';
import { ControlLabel } from 'react-bootstrap';

interface IProps {
    isDonorCenter: boolean,
    rdnCenterId: number,
    pickupCenterAlias: string,
    pickupAddress: ICenterAddress,
    shipToCenterAlias: string,
    shipToAddress: ICenterAddress,
    kidneyPickupDateTime: string,
    kidneyArrivalDateTime: string,
    onEditCenterAddress: (centerAddress: ICenterAddress) => void
}

const CenterAddresses = (props: IProps) => {
    const handleEditCenterAddress = (e: ReactMouseEvent<HTMLSpanElement, MouseEvent>, address: ICenterAddress) => {
        e.preventDefault();
        props.onEditCenterAddress(address);
    };

    return (
        <>
            {props.isDonorCenter && (
                <>
                    <div style={{ paddingLeft: '2%', float: 'left', width: '32%' }}>
                        <a style={{ cursor: 'default' }} onClick={(e: ReactMouseEvent<HTMLSpanElement, MouseEvent>) => props.rdnCenterId == 0 && props.isDonorCenter ? handleEditCenterAddress(e, props.pickupAddress) : null}>
                            <ControlLabel style={{ color: '#333' }}>Kidney Pickup</ControlLabel>
                            <div>{props.pickupCenterAlias}</div>
                            <span style={{ overflow: 'hidden' }}>
                                <div>{props.pickupAddress.addressLine1}</div>

                                {props.pickupAddress.addressLine2 != '' && (
                                    <div>{props.pickupAddress.addressLine2}</div>
                                )}

                                {props.pickupAddress.addressLine3 != '' && (
                                    <div>{props.pickupAddress.addressLine3}</div>
                                )}

                                <div>{props.pickupAddress.city}, {props.pickupAddress.stateAbbreviation} {props.pickupAddress.postalCode}</div>

                                {props.kidneyPickupDateTime != '' && (
                                   <div>Pickup: {props.kidneyPickupDateTime}</div>
                                )}
                            </span>
                        </a>
                    </div>

                    <div style={{ paddingLeft: '2%', float: 'left', width: '32%' }}>
                        <ControlLabel style={{ color: '#333' }}>Kidney Ship To</ControlLabel>
                        <div>{props.shipToCenterAlias}</div>
                        <span style={{ overflow: 'hidden' }}>
                            <div>{props.shipToAddress.addressLine1}</div>

                            {props.shipToAddress.addressLine2 != '' && (
                                <div>{props.shipToAddress.addressLine2}</div>
                            )}

                            {props.shipToAddress.addressLine3 != '' && (
                                <div>{props.shipToAddress.addressLine3}</div>
                            )}

                            <div>{props.shipToAddress.city}, {props.shipToAddress.stateAbbreviation} {props.shipToAddress.postalCode}</div>

                            {props.kidneyArrivalDateTime != '' && (
                                <div>Delivery: {props.kidneyArrivalDateTime}</div>
                            )}
                        </span>
                    </div>
                </>
            )}

            {!props.isDonorCenter && (
                <>
                    <div style={{ paddingLeft: '2%', float: 'left', width: '32%' }}>
                        <ControlLabel style={{ color: '#333' }}>Kidney Pickup</ControlLabel>
                        <div>{props.pickupCenterAlias}</div>
                        <span style={{ overflow: 'hidden' }}>
                            <div>{props.pickupAddress.addressLine1}</div>

                            {props.pickupAddress.addressLine2 != '' && (
                                <div>{props.pickupAddress.addressLine2}</div>
                            )}

                            {props.pickupAddress.addressLine3 != '' && (
                                <div>{props.pickupAddress.addressLine3}</div>
                            )}

                            <div>{props.pickupAddress.city}, {props.pickupAddress.stateAbbreviation} {props.pickupAddress.postalCode}</div>

                            {props.kidneyPickupDateTime != '' && (
                                <div>Pickup: {props.kidneyPickupDateTime}</div>
                            )}
                        </span>
                    </div>

                    <div style={{ paddingLeft: '2%', float: 'left', width: '32%' }}>
                        <a style={{ cursor: 'default' }} onClick={(e: ReactMouseEvent<HTMLSpanElement, MouseEvent>) => handleEditCenterAddress(e, props.shipToAddress)}>
                            <ControlLabel style={{ color: '#333' }}>Kidney Ship-To</ControlLabel>
                            <div>{props.shipToCenterAlias}</div>
                            <span style={{ overflow: 'hidden' }}>
                                <div>{props.shipToAddress.addressLine1}</div>

                                {props.shipToAddress.addressLine2 != '' && (
                                    <div>{props.shipToAddress.addressLine2}</div>
                                )}

                                {props.shipToAddress.addressLine3 != '' && (
                                    <div>{props.shipToAddress.addressLine3}</div>
                                )}

                                <div>{props.shipToAddress.city}, {props.shipToAddress.stateAbbreviation} {props.shipToAddress.postalCode}</div>

                                {props.kidneyArrivalDateTime != '' && (
                                    <div>Delivery: {props.kidneyArrivalDateTime}</div>
                                )}
                            </span>
                        </a>
                    </div>
                </>
            )}
        </>
    );
}

export default CenterAddresses;